import type { MetaFunction } from "@remix-run/node";

import "../privacy.scss";

export const meta: MetaFunction = () => {
  return [{ title: "Tempt - List of Partners" }];
};

export default function PrivacyPolicy() {
  return (
    <section className="text-white pt-10 terms">
      <div className="container">
        <h1 className="page-title">LIST OF PARTNERS</h1>
        <span>Last Updated: April 01, 2025</span>
        <div className="page-body">
          <div>
            <p>
              To support delivery of our Services, Womanly Corp. may engage and
              use service providers and other partners with access to certain
              personal data (each, a "Partner"). This page provides important
              information about the identity, location and role of each Partner.
              Terms used on this page, but not defined, have the meaning set
              forth in our <a href="/privacy_policy">Privacy Policy</a>.
            </p>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">No</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Name of Service We Use</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Partner Name</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Partner Role</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Partner Location</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Partner Data Privacy Practices
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">1</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Firebase</span>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Google LLC</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://www.google.com/policies/privacy/">
                        <span className="Hyperlink1">
                          https://www.google.com/policies/privacy/
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://firebase.google.com/support/privacy#examples-end-user-data-processed-by-firebase">
                        <span className="Hyperlink1">
                          https://firebase.google.com/support/privacy#examples-end-user-data-processed-by-firebase
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://firebase.google.com/docs/android/play-data-disclosure">
                        <span className="Hyperlink1">
                         https://firebase.google.com/docs/android/play-data-disclosure
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">2</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Adjust</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Adjust GmbH</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Germany</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://help.adjust.com/en/article/google-play-data-safety">
                        <span className="Hyperlink1">
                          https://help.adjust.com/en/article/google-play-data-safety
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">3</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Amplitude</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Amplitude Inc.</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://amplitude.com/privacy">
                        <span className="Hyperlink1">
                          https://amplitude.com/privacy
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>4</p>
                  </td>
                  <td>
                    <p className="Default">temporal.io</p>
                  </td>
                  <td>
                    <p>Temporal Rechnologies INC.</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Cloud computing service, used for secure data storage
                      </span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p>
                      <a href="https://temporal.io/global-privacy-policy">
                        <span className="Hyperlink2">
                          https://temporal.io/global-privacy-policy
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">5</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Page Insights (Facebook)</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Meta Platforms Ireland Limited
                      </span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Analytics service providing us with aggregated
                        statistics and analytics data on how Facebook users
                        interact with our page and its content&nbsp;
                      </span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Ireland</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://www.facebook.com/legal/terms/information_about_page_insights_data">
                        <span className="Hyperlink1">
                          https://www.facebook.com/legal/terms/information_about_page_insights_data
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">6</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Google Analytics</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Google LLC</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://support.google.com/analytics/answer/11582702?hl=en">
                        <span className="Hyperlink1">
                          https://support.google.com/analytics/answer/11582702?hl=en
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://www.google.com/policies/privacy/">
                        <span className="Hyperlink1">
                          https://www.google.com/policies/privacy/
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">7</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">AWS</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Amazon Web Services, Inc.</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Cloud computing service, used for secure data storage
                      </span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://aws.amazon.com/compliance/data-privacy-faq/">
                        <span className="Hyperlink1">
                          https://aws.amazon.com/compliance/data-privacy-faq/
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">8</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Google Cloud</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Google LLC</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Cloud computing service, used for secure data storage
                      </span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">USA</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://cloud.google.com/terms/data-processing-addendum">
                        <span className="Hyperlink1">
                          https://cloud.google.com/terms/data-processing-addendum
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p className="Body">
                      <span className="None">9</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Paddle.com</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Paddle.com Market Ltd</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Payment provider</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">UK</span>
                    </p>
                  </td>
                  <td>
                    <p className="Body">
                      <a href="https://www.paddle.com/legal/privacy">
                        <span className="Hyperlink1">
                          https://www.paddle.com/legal/privacy
                        </span>
                      </a>
                      <span className="None">&nbsp;</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>10</p>
                  </td>
                  <td>
                    <p>Datadog</p>
                  </td>
                  <td>
                    <p>Datadog Inc.</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://www.datadoghq.com/legal/data-processing-addendum/">
                        <span className="Hyperlink2">
                          https://www.datadoghq.com/legal/data-processing-addendum/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>11</p>
                  </td>
                  <td>
                    <p>Sentry</p>
                  </td>
                  <td>
                    <p>Functional Software, Inc</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Analytics service</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://sentry.io/legal/dpa/">
                        <span className="Hyperlink2">
                          https://sentry.io/legal/dpa/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>12</p>
                  </td>
                  <td>
                    <p>Cloudfare</p>
                  </td>
                  <td>
                    <p>Cloudfare, Inc</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">
                        Cloud computing service, used for secure data storage
                      </span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://www.cloudflare.com/trust-hub/privacy-and-data-protection/">
                        <span className="Hyperlink2">
                          https://www.cloudflare.com/trust-hub/privacy-and-data-protection/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>13</p>
                  </td>
                  <td>
                    <p>Stripe</p>
                  </td>
                  <td>
                    <p>Stripe, Inc</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Payment provider</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://stripe.com/legal/privacy-center">
                        <span className="Hyperlink2">
                          https://stripe.com/legal/privacy-center
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://stripe.com/privacy">
                        <span className="Hyperlink2">
                          https://stripe.com/privacy
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>14</p>
                  </td>
                  <td>
                    <p>TikTok</p>
                  </td>
                  <td>
                    <p>TikTok Inc.</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Marketing partners (platforms), which we use to advertise our services, as well as to improve and measure our advertising campaigns on such platforms</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://www.tiktok.com/privacy/ads-and-your-data/en">
                        <span className="Hyperlink2">
                          https://www.tiktok.com/privacy/ads-and-your-data/en
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://www.tiktok.com/legal/page/us/privacy-policy/en">
                        <span className="Hyperlink2">
                          https://www.tiktok.com/legal/page/us/privacy-policy/en
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>15</p>
                  </td>
                  <td>
                    <p>Facebook</p>
                  </td>
                  <td>
                    <p>Meta Platforms Inc.</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Marketing partners (platforms), which we use to advertise our services, as well as to improve and measure our advertising campaigns on such platforms</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://www.facebook.com/privacy/guide/ads/">
                        <span className="Hyperlink2">
                           https://www.facebook.com/privacy/guide/ads/
                        </span>
                      </a>
                      <br/>
                      <br/>
                      <a href="https://www.facebook.com/privacy/policy/">
                        <span className="Hyperlink2">
                           https://www.facebook.com/privacy/policy/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>16</p>
                  </td>
                  <td>
                    <p>AppLovin</p>
                  </td>
                  <td>
                    <p>AppLovin Corporation</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Advertising networks, i.e. advertising partners we engage to show advertising in our Services</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://www.applovin.com/multistate-privacy-notice/">
                        <span className="Hyperlink2">
                           https://www.applovin.com/multistate-privacy-notice/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>17</p>
                  </td>
                  <td>
                    <p>Admob</p>
                  </td>
                  <td>
                    <p>Google LLC</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Advertising network, i.e. advertising partners we engage to show advertising in our Services</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://policies.google.com/privacy?hl=en&gl=US">
                        <span className="Hyperlink2">
                           https://policies.google.com/privacy?hl=en&gl=US
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>18</p>
                  </td>
                  <td>
                    <p>Liftoff Monetize</p>
                  </td>
                  <td>
                    <p>Liftoff Mobile Limited</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Advertising network, i.e. advertising partners we engage to show advertising in our Services</span>
                    </p>
                  </td>
                  <td>
                    <p>UK</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://liftoff.io/privacy-policy/">
                        <span className="Hyperlink2">
                           https://liftoff.io/privacy-policy/
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>19</p>
                  </td>
                  <td>
                    <p>Unity</p>
                  </td>
                  <td>
                    <p>Unity Technologies</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Advertising network, i.e. advertising partners we engage to show advertising in our Services</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://unity.com/ru/legal/privacy-policy">
                        <span className="Hyperlink2">
                           https://unity.com/ru/legal/privacy-policy
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>20</p>
                  </td>
                  <td>
                    <p>Google AdSense</p>
                  </td>
                  <td>
                    <p>Google LLC</p>
                  </td>
                  <td>
                    <p className="Body">
                      <span className="None">Advertising network, i.e. advertising partners we engage to show advertising in our Services</span>
                    </p>
                  </td>
                  <td>
                    <p>USA</p>
                  </td>
                  <td>
                    <p>
                      <a href="https://policies.google.com/privacy">
                        <span className="Hyperlink2">
                          https://policies.google.com/privacy
                        </span>
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              In the future, we may collaborate with new partners or modify our
              current partnerships to enhance our Services. To keep you
              informed, we will update the list of our partners here.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
